import { render, staticRenderFns } from "./schoolBuilding.vue?vue&type=template&id=37e73c80&scoped=true&"
import script from "./schoolBuilding.vue?vue&type=script&lang=js&"
export * from "./schoolBuilding.vue?vue&type=script&lang=js&"
import style0 from "./schoolBuilding.vue?vue&type=style&index=0&id=37e73c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e73c80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
